export function wrapTextLines(
    ctx: CanvasRenderingContext2D,
    text: string,
    maxWidth: number,
): string[] {
    if (!text) return [];
    const lines: string[] = [];
    const paragraphs = text.split('\n');
    paragraphs.forEach((paragraph, idx) => {
        if (!paragraph.trim()) {
            lines.push('');
            return;
        }
        const words = paragraph.split(/\s+/);
        let current = words[0] || '';
        for (let i = 1; i < words.length; i += 1) {
            const next = `${current} ${words[i]}`;
            if (ctx.measureText(next).width <= maxWidth) {
                current = next;
            } else {
                lines.push(current);
                current = words[i] || '';
            }
        }
        lines.push(current);
        if (idx < paragraphs.length - 1) lines.push('');
    });
    return lines;
}
